import React from 'react'

const Policy: React.FC = () => {
  return (
    <>
      <style>{`
        .policy-container {
          width: 100%;
          max-width: 800px;
          margin: 0 auto;
          padding: 60px 50px;
          background-color: #ffffff;
          color: #000000;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 15px;
          line-height: 1.65;
          box-shadow: 0 0 20px rgba(0,0,0,0.12);
          border: 1px solid #ddd;
          border-radius: 8px;

          /* AQUI ESTÁ O FIX DO SCROLL */
          height: 100vh;
          overflow-y: auto;
          overflow-x: hidden;
        }

        .policy-container h1 {
          text-align: center;
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .policy-container .date {
          text-align: center;
          font-size: 13px;
          color: #444;
          margin-bottom: 35px;
        }

        .policy-container h2 {
          font-size: 18px;
          font-weight: bold;
          margin: 40px 0 12px;
        }

        .policy-container p {
          margin-bottom: 18px;
          text-align: justify;
        }

        .policy-container ul, .policy-container ol {
          margin-left: 25px;
          margin-bottom: 20px;
        }

        .policy-container li {
          margin-bottom: 12px;
          display: flex;
          gap: 8px;
        }

        .policy-container .bullet {
          font-size: 18px;
          line-height: 1;
        }

        .policy-container a {
          color: #0066cc;
          text-decoration: underline;
        }

        .policy-container strong {
          font-weight: bold;
        }

        /* Scrollbar mais bonita */
        .policy-container::-webkit-scrollbar {
          width: 8px;
        }
        .policy-container::-webkit-scrollbar-thumb {
          background: #aaa;
          border-radius: 4px;
        }
      `}</style>

      <div className="policy-container">
        <h1>POLÍTICA DE PRIVACIDADE</h1>

        <p>
          Aqui você encontrará nossas diretrizes a respeito de como coletamos,
          tratamos e protegemos informações e dados dos nossos{' '}
          <strong>USUÁRIOS</strong> e visitantes. O objetivo desse documento é
          prestar informações para ajudá-lo a decidir conscientemente sobre o
          compartilhamento de informações e sobre a utilização do Site.
        </p>

        <p>
          Entende-se como Site o endereço virtual{' '}
          <a
            href="https://www.attogroup.com.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.attogroup.com.br
          </a>{' '}
          e o dispositivo móvel disponibilizado pela ATTO CONSTRUTORA LTDA na
          Apple Store e Play Store.
        </p>

        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          Caso você não esteja de acordo com os termos da presente Política,
          ainda que parcialmente, por favor, não aceite ou utilize nossos
          serviços.
        </p>

        <p>
          Em caso de dúvidas, favor entrar em contato através dos canais de
          comunicação:{' '}
          <a href="mailto:Tecnologia@attogroup.com.br">
            Tecnologia@attogroup.com.br
          </a>
          /
          <a href="mailto:atendimento@attogroup.com.br">
            atendimento@attogroup.com.br
          </a>
        </p>

        <h2>1. ACEITE</h2>
        <p>
          Ao manifestar o “Aceite” desta Política de Privacidade, o USUÁRIO
          declara expressamente que leu e entendeu todos os direitos aqui
          determinados, concordando e sujeitando-se a todas as disposições do
          presente instrumento.
        </p>
        <p>
          A presente Política de Privacidade abrange o tratamento que a ATTO
          CONSTRUTORA LTDA dá às informações capazes de identificar e acessar os
          dados dos USUÁRIOS. Isso tudo no momento em que estes visitam e se
          cadastram no Site, por meio do fornecimento de informações, as quais
          serão mantidas durante o período em que o respectivo cadastro estiver
          ativo.
        </p>

        <h2>2. DIREITOS DO USUÁRIO</h2>
        <p>Aos USUÁRIOS são garantidos os seguintes direitos:</p>
        <ul>
          <li>
            <span className="bullet">●</span> <strong>Direito de acesso</strong>{' '}
            – o direito de solicitar acesso aos respectivos dados pessoais que
            processamos sobre o USUÁRIO.
          </li>
          <li>
            <span className="bullet">●</span>{' '}
            <strong>Direito de retificação</strong> – o direito a solicitar que
            a ATTO CONSTRUTORA LTDA altere ou atualize os dados pessoais do
            USUÁRIO, sempre que estiverem incorretos ou incompletos.
          </li>
          <li>
            <span className="bullet">●</span>{' '}
            <strong>
              Direito à anonimização, bloqueio ou eliminação de dados
              desnecessários ou excessivos
            </strong>{' '}
            – direito a tornar anônimo seus dados, ou exigir sua eliminação
            quando forem desnecessários ou excessivos para a finalidade em
            questão.
          </li>
          <li>
            <span className="bullet">●</span>{' '}
            <strong>Direito à portabilidade de dados</strong> – o direito de
            solicitar uma cópia dos seus dados pessoais em formato eletrônico,
            assim como o direito de transmitir esses dados pessoais para
            utilização de serviços prestados por terceiros.
          </li>
          <li>
            <span className="bullet">●</span>{' '}
            <strong>Direito à eliminação da informação</strong> – o direito a
            solicitar-nos para apagar os seus dados pessoais após o fim da
            prestação dos serviços, exceto aqueles considerados obrigatórios por
            determinação legal.
          </li>
          <li>
            <span className="bullet">●</span>{' '}
            <strong>Direito à informação</strong> – o direito de saber com que
            entidades – públicas ou privadas – a ATTO CONSTRUTORA LTDA
            compartilhou seus dados.
          </li>
          <li>
            <span className="bullet">●</span>{' '}
            <strong>Direito à revogação</strong> – o direito de revogar, a
            qualquer tempo, o consentimento para uso de dados.
          </li>
        </ul>

        <p>
          Estes direitos deverão ser exercidos pelo USUÁRIO através de
          requerimento expresso, através do canal de comunicação descrito nesta
          Política. O USUÁRIO receberá uma resposta, pelo mesmo meio de
          comunicação, em até 10 (dez) dias úteis do envio da solicitação.
        </p>

        <h2>3. DOCUMENTOS E INFORMAÇÕES COLETADAS</h2>
        <p>
          Nosso site coleta informações pessoais dos USUÁRIOS nas seguintes
          situações:
        </p>

        <p>
          <strong>A.</strong> Ao realizar o cadastramento no Site, processando
          os seguintes dados que podem ser fornecidos pelos USUÁRIOS: IP do
          usuário, nome do browser, nome do sistema, aparelho, fuso horário,
          source (convidados, anúncios, pesquisa de internet, etc.), nome, CPF,
          telefone Celular, e-mail e endereço (Pessoa Física) / Cartão CNPJ,
          e-mail e telefone celular (Pessoa Jurídica).
        </p>

        <p>
          <strong>OBS:</strong> Alguns documentos poderão ser solicitados no
          momento de adesão de um dos serviços oferecidos pela ATTO CONSTRUTORA
          LTDA. A título exemplificativo, poderão ser requeridos:
        </p>
        <ol style={{ marginLeft: '30px', marginBottom: '20px' }}>
          <li>
            Documento de identificação pessoal oficial: USUÁRIO deve enviar um
            documento de identificação oficial, que contenha foto e o CPF do
            titular, além de uma “Selfie” segurando o documento com foto.
          </li>
          <li>
            Comprovante de residência: USUÁRIO deve enviar comprovante de
            residência atualizado em seu nome. Caso o documento esteja em nome
            de terceiro, possível apenas para membros da família, deve ser
            comprovado vínculo familiar (certidão de casamento, nascimento,
            etc).
          </li>
        </ol>

        <p>
          <strong>B.</strong> No momento do preenchimento de qualquer formulário
          de contato, quando são processados todos os dados nele inseridos pelos
          USUÁRIOS ou visitantes;
        </p>
        <p>
          <strong>C.</strong> Quando do envio voluntário de informações por
          e-mail pelos USUÁRIOS, dados que também se limitam a essas
          informações;
        </p>
        <p>
          <strong>D.</strong> Ao realizar qualquer acesso à página ou aplicativo
          (via smartphones) da ATTO CONSTRUTORA LTDA, por meio de cookies e
          outras tecnologias, quando serão processados o endereço IP do USUÁRIO,
          nome do browser, nome do sistema, aparelho, fuso horário, source
          (convidados, anúncios, pesquisa de internet, etc.)
        </p>

        <h2>4. FINALIDADE DOS DADOS TRATADOS</h2>
        <p>
          O USUÁRIO concorda e autoriza o uso dos dados tratados para os
          seguintes fins:
        </p>
        <ul>
          <li>
            <span className="bullet">●</span> Os dados coletados conforme o
            descrito no item “A” acima – para possibilitar o acesso aos serviços
            do Site, bem como para que a ATTO CONSTRUTORA LTDA possa se utilizar
            da ferramenta de dupla verificação do USUÁRIO;
          </li>
          <li>
            <span className="bullet">●</span> Os dados coletados conforme o
            descrito no item “B” acima – para envio de informativos e promoções;
          </li>
          <li>
            <span className="bullet">●</span> Os dados coletados conforme o
            descrito no item “C” acima – para responder às solicitações dos
            usuários;
          </li>
          <li>
            <span className="bullet">●</span> Os dados coletados conforme o
            descrito no item “A” e “D” acima – (i) para pesquisa e análise; (ii)
            para aprimorar nossa tecnologia (iii) para registro de acesso; (iv)
            aprimoramento das ferramentas de segurança; (v) para a identificação
            do USUÁRIO; (vi) para cumprimento de obrigações legais, contratuais
            ou regulatórias; e (vii) para serviços e ações de remarketing.
          </li>
        </ul>

        {/* Restante do conteúdo (5 a 13) — idêntico ao PDF */}
        <h2>5. COMPARTILHAMENTO DE DADOS</h2>
        <p>
          Os dados coletados, desde que para uso em conformidade com a
          finalidade acima exposta, poderão ser compartilhados com outras
          empresas que prestam serviços diretamente para a ATTO CONSTRUTORA
          LTDA, esses dados quando compartilhados passam por processo de
          anonimização, e, portanto, não são capazes de identificar qualquer
          USUÁRIO.
        </p>
        <p>
          Todas as prestadoras de serviço da ATTO CONSTRUTORA LTDA são
          submetidas a rigoroso compromisso de confidencialidade e cuidado com
          os dados, no mesmo nível do quanto aqui se compromete a ATTO
          CONSTRUTORA LTDA. Nenhuma das informações divulgadas pela ATTO
          CONSTRUTORA LTDA são capazes de identificar os USUÁRIOS,
          preservando-se a confidencialidade dos dados pessoais dos USUÁRIOS,
          salvo nas situações elencadas no Capítulo “TEMPO DE DURAÇÃO DO
          TRATAMENTO DE DADOS”.
        </p>

        <h2>6. TRANSFERÊNCIA DOS DADOS A OUTROS PAÍSES</h2>
        <p>
          A ATTO CONSTRUTORA LTDA informa ainda que os dados coletados poderão
          ser transferidos a outros países, onde empresas coligadas e
          prestadores de serviço estão sediados, ficando claro que o USUÁRIO, ao
          concordar com a presente Política de Privacidade, outorga também
          concordância específica e expressa ao compartilhamento e transferência
          dos seus dados estes países, com a finalidade da execução dos serviços
          da ATTO CONSTRUTORA LTDA.
        </p>

        <h2>7. TEMPO DE DURAÇÃO DO TRATAMENTO DOS DADOS</h2>
        <p>
          Os dados coletados serão tratados pela ATTO CONSTRUTORA LTDA somente
          enquanto subsistir o consentimento e a relação entre o USUÁRIO e a
          ATTO CONSTRUTORA LTDA, exceto na hipótese de tais dados serem
          necessários para:
        </p>
        <ul>
          <li>
            <span className="bullet">●</span> Cumprimento de obrigação legal ou
            regulatória da ATTO CONSTRUTORA LTDA;
          </li>
          <li>
            <span className="bullet">●</span> Uso exclusivo da ATTO CONSTRUTORA
            LTDA, desde que estes dados sejam anonimizados
          </li>
          <li>
            <span className="bullet">●</span> O exercício regular de direitos em
            processo judicial, administrativo ou arbitral do ATTO CONSTRUTORA
            LTDA ou quando necessário para atender aos interesses legítimos da
            ATTO CONSTRUTORA LTDA
          </li>
        </ul>

        <h2>8. DISPOSIÇÃO DOS DADOS PELO USUÁRIO</h2>
        <p>
          Caso haja alterações nesta Política de Privacidade, estas serão
          informadas ao público em geral por anúncio em nossa página principal e
          aos USUÁRIOS cadastrados por e-mail. Além disso, no início deste
          documento é possível verificar a data em que esta Política foi
          atualizada pela última vez.
        </p>
        <p>
          Os USUÁRIOS serão sempre informados sobre os dados a serem coletados,
          ficando a seu critério fornecê-los ou não, bem como a sua exclusão
          posterior, e, em cada caso, serão avisados sobre as consequências de
          sua decisão.
        </p>
        <p>
          O USUÁRIO garante a veracidade e exatidão dos dados pessoais
          fornecidos no Site, assumindo a correspondente responsabilidade caso
          eles não sejam exatos. Constitui ainda como responsabilidade do
          USUÁRIO o dever de manter atualizados seus dados cadastrais,
          principalmente o e-mail, adotando as devidas cautelas para que os
          e-mails do Site não sejam enviados para a caixa de lixo eletrônico.
        </p>

        <h2>9. CONTATO ENTRE A ATTO CONSTRUTORA LTDA E USUÁRIOS</h2>
        <p>
          O acesso às informações coletadas é restrito aos colaboradores da ATTO
          CONSTRUTORA LTDA e pessoas autorizadas nas situações elencadas no
          Capítulo “TEMPO DE DURAÇÃO DO TRATAMENTO DE DADOS”.
        </p>
        <p>
          Além disso, o USUÁRIO se declara ciente de que os dados poderão ser
          compartilhados com eventuais empresas do seu grupo econômico, o que
          inclui empresas sediadas no exterior.
        </p>
        <p>
          Empregados ou pessoas autorizadas que se utilizarem indevidamente de
          informações, ferindo essa Política de Privacidade, estarão sujeitos às
          medidas legais cabíveis.
        </p>
        <p>
          Os dados e informações do USUÁRIO e suas atividades também poderão ser
          compartilhados para atender solicitações judiciais, de agências
          reguladoras e/ou órgãos do governo e para instruir processos
          investigativos de cooperação internacional, conforme autorizado pela
          legislação vigente.
        </p>

        <h2>10. SEGURANÇA DA INFORMAÇÃO</h2>
        <p>
          O USUÁRIO tem conhecimento que sempre há risco no tráfego de
          informações da internet, porém, a ATTO CONSTRUTORA LTDA se compromete
          a utilizar os melhores padrões de mercado para proteger os dados de
          seus USUÁRIOS.
        </p>

        <h2>11. CANAL DE COMUNICAÇÃO</h2>
        <p>
          Para estabelecer contato entre a ATTO CONSTRUTORA LTDA e o USUÁRIO,
          fica disponibilizado o endereço eletrônico:{' '}
          <a href="mailto:Tecnologia@attogroup.com.br">
            Tecnologia@attogroup.com.br
          </a>{' '}
          /{' '}
          <a href="mailto:atendimento@attogroup.com.br">
            atendimento@attogroup.com.br
          </a>
          , sendo certo que o USUÁRIO se obriga, igualmente, a manter atualizado
          seu endereço eletrônico no Site, visto que por intermédio deste se
          farão eventuais comunicações pertinentes.
        </p>

        <h2>12. DISPOSIÇÕES GERAIS</h2>
        <p>
          Na hipótese de qualquer uma das disposições desta Política vir a ser
          considerada contrária à lei brasileira, as demais disposições não
          afetadas continuarão em vigor e as partes deverão alterar este
          instrumento de forma a adequá-lo a tal lei.
        </p>

        <h2>13. DA SOLUÇÃO DE CONFLITOS</h2>
        <p>
          As partes contratantes elegem o Foro da Comarca de São Paulo/SP para
          eventual solução de quaisquer questões decorrentes da execução deste
          Termo.
        </p>
        <div
          style={{
            marginTop: '80px',
            textAlign: 'center',
            fontSize: '12px',
            color: '#666',
          }}
        >
          ATTO CONSTRUTORA LTDA • Política de Privacidade
        </div>
      </div>
    </>
  )
}

export default Policy
